import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useProductCenterApi } from 'api';
import { unitIsTelematicQuery } from 'api/queries/UnitQueries';
import { reactPlugin } from 'main/azureInsights/config';
import { useResolvedUnitIds } from 'modules/Shared/Components/Hooks/useNumberParam';
import { LegacySection } from 'modules/UnitOverview/Components/LegacySection';

const TelematicsSectionPage = (): React.JSX.Element => {
	const { t } = useTranslation(['unitOverview']);
	const { api } = useProductCenterApi();

	const unitIds = useResolvedUnitIds();

	const unitQuery = useSuspenseQuery(unitIsTelematicQuery(api, unitIds.id));

	return (
		<LegacySection
			unitId={unitIds.id}
			mvcAction={'UnitOverview/TelematicsOverview'}
			label={t('unitOverview:telematics-view-services')}
			disabled={!unitQuery.data}
		/>
	);
};

export default withAITracking(
	reactPlugin,
	TelematicsSectionPage,
	'UnitOverviewTelematicsSectionPage',
	'application-insight-container'
);
